
  import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
  export default class GroupTaskDetail extends Vue {
  @Prop() event: Record<string, any>
  }
